// removed by extract-text-webpack-plugin
module.exports = {"title":"_-src-components-ReviewStep-styles---title---_gqgq","details":"_-src-components-ReviewStep-styles---details---1TP0E"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReviewStep/styles.css
// module id = 780
// module chunks = 0